export function EditDivider (pEditor, pDivider)
{
  this.closeEditDividerDialog = (pButton) =>
  {
    if (pEditor.pDialog)
    {
      pEditor.closeDialog();
    }
  };
}